import { Button, message } from "antd";
import WeaError from "../../wea-error";
import WeaTools from "../../wea-tools";
import WeaDialog from "../../wea-dialog";
import WeaLocaleProvider from "../../wea-locale-provider";
import Search from "./Search";
import constant from "./constant";

const { getLoginConditions } = constant;
const getLabel = WeaLocaleProvider.getLabel;
class Main extends React.Component {
  static defaultProps = {
    prefixCls: "wea-ecode-login",
    modalStyle: {
      width: 600
    }
  };
  constructor(props) {
    super(props);
    this.state = {
      visible: props.visible || false,
      csAccount: "",
      csPassword: "",
      loginCondtions: getLoginConditions(),
      loading: false
    };
  }
  componentDidMount() {
    const { visible } = this.props;
    this.setState({ visible }, () => {
      this.initConditions();
    });
  }

  componentWillReceiveProps(nextProps) {
    const { visible } = nextProps;
    const { visible: _visible } = this.props;
    if (visible !== _visible) {
      this.setState({ visible }, () => {
        this.initConditions();
      });
    }
  }

  initConditions = () => {
    if (this.state.visible) {
      this.setState({
        loginCondtions: getLoginConditions(
          {
            account: this.state.csAccount,
            password: this.state.csPassword,
            explain: getLabel("82279", "点击查看")
          },
          {
            account: getLabel("517387", "云商店账号"),
            password: getLabel("518771", "云商店账号密码"),
            explain: getLabel("518772", "云商店登录和分享说明")
          }
        )
      });
    }
  };

  onCancel = () => {
    const { onCancel } = this.props;
    this.setState({ visible: false });
    typeof onCancel === "function" && onCancel();
  };
  changeCondition = fields => {
    if (fields.account) {
      this.setState({ csAccount: fields.account.value });
    }
    if (fields.password) {
      this.setState({ csPassword: fields.password.value });
    }
  };
  checkNull = val => {
    return !val || val === "";
  };
  bindToken = () => {
    const { csAccount, csPassword } = this.state;
    let pass = true;
    if (this.checkNull(csAccount)) {
      this.WeaEcodeUploadLogin_account.showError();
      pass = false;
    }
    if (this.checkNull(csPassword)) {
      this.WeaEcodeUploadLogin_password.showError();
      pass = false;
    }
    if (pass) {
      this.setState({ loading: true });
      WeaTools.callApi("/api/ecode/demo/bindTokens", "POST", {
        account: csAccount,
        password: csPassword
      }).then(data => {
        this.setState({ loading: false });
        if (data.api_status) {
          WeaTools.ls.set("csToken", data.cs_token);
          this.onCancel();
        } else {
          message.error(data.msg);
        }
      });
    }
  };
  render() {
    const { prefixCls, modalStyle, icon, iconBgcolor } = this.props;
    const { visible, loading, loginCondtions } = this.state;
    const buttons = [
      <Button
        type="primary"
        key="ok"
        loading={loading}
        onClick={this.bindToken}
      >
        {getLabel("83446", "确定")}
      </Button>,
      <Button key="cancel" onClick={this.onCancel}>
        {getLabel("201", "取消")}
      </Button>
    ];
    return (
      <div className={prefixCls}>
        <WeaDialog
          destroyBodyOnClose
          style={modalStyle}
          visible={visible}
          title={getLabel("518774", "登录云商店")}
          icon={icon}
          iconBgcolor={iconBgcolor}
          maskClosable={false}
          buttons={buttons}
          onCancel={this.onCancel}
        >
          <Search
            browserConditions={loginCondtions}
            changeCondition={this.changeCondition}
            ref={el => (this.ecodeUploadLogin = el)}
            errorCom={(field, children) => {
              return (
                <WeaError
                  ref={el => (this[`WeaEcodeUploadLogin_${field.domkey}`] = el)}
                  className="wea-ecode-upload-errorTip"
                  error={`${field.label}${getLabel(
                    "386957",
                    ":attribute 未填写"
                  ).replace(/:attribute/, "")}`}
                  tipPosition="bottom"
                >
                  {children}
                </WeaError>
              );
            }}
          />
        </WeaDialog>
      </div>
    );
  }
}
export default Main;



// WEBPACK FOOTER //
// ./ecology9/base/wea-ecode-login/index.js